import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

import { useMediaQuery } from '@mantine/hooks';

import router from '@/router/router.tsx';

import { isMobileParam } from '@/shared/helpers/media';
import useAppStore from '@/shared/store/app.store';
import { PullToRefresh } from '@/shared/uikit/components/pullToRefresh';

import './app.css';

function App() {
	const isMobile = useMediaQuery(isMobileParam);
	const setIsMobile = useAppStore((state) => state.setIsMobile);

	useEffect(() => {
		if (isMobile !== undefined) {
			console.log(isMobile ? 'Mobile' : 'Desktop');
			setIsMobile(isMobile);
		}
	}, [isMobile]);

	return (
		<>
			<PullToRefresh />
			<RouterProvider router={router} />
		</>
	);
}

export default App;
